/* eslint-disable */
import { MessagePathDto } from '../dto/message-path-dto';

export interface MailAccountGetMessageListResponseDtoMessageListItem {
  subject: string;
  messagePathForImport: MessagePathDto;
  date: Date | null;
  from: string;
}

export const fixMailAccountGetMessageListResponseDtoMessageListItemFromJson = (dto?: MailAccountGetMessageListResponseDtoMessageListItem | null): void => {
  if (!dto) {
    return;
  }
  dto.date = dto.date && new Date(dto.date);
};

export const fixMailAccountGetMessageListResponseDtoMessageListItemToJson = (dto?: MailAccountGetMessageListResponseDtoMessageListItem | null): void => {
  if (!dto) {
    return;
  }
};
